<template>
  <div class="emphasizeBox" v-html-safe="text"></div>
</template>

<script>
export default {
  name: 'EmphasizeBox',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.emphasizeBox {
  color: #19222b;
  background: #f0f4f7;
  text-align: left;
  border-radius: 6px;
  padding: 8px;
  font-size: 14px;
  line-height: 21px;
}
</style>
